export default __webpack_public_path__ + "static/article-how-car-ownership-has-shifted-gears-7250a53dcf7dde0d0ce8096b073db211.jpg";